import store     from '@/store/index'
import constants from '@/commons/constants'

export default function authenticatedMiddleware({ next }) {

    return store.getters['sessionData/currentUser']
        ? next()
        : next({ name: constants.LOGIN_ROUTE_NAME })

}